import axios from 'ui/utils/axios';
import { IError } from 'ui/interfaces/entities/apiError';
import { IWidgetResponse } from 'ui/interfaces/entities/clinical/widget';

export namespace GET {
  export type IResponse = IWidgetResponse;

  export type IResponseError = IError;

  export interface IStarted {
    id: string;
  }

  export const getUrl = (API: string) => API;

  export const service = (API: string) => axios.get<IResponse>(getUrl(API));
}
